import { gql } from '@apollo/client';
import POST_FIELDS_FRAGMENT from './fragments/PostFields';

export default gql`
  query unorganized(
    $afterCursor: String
    $first: Int = 20
    $filter: UnorganizedPostsFilter
    $orderBy: UnorganizedPostsOrder
  ) {
    unorganized(
      first: $first
      after: $afterCursor
      filter: $filter
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PostFields
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
  ${POST_FIELDS_FRAGMENT}
`;
